import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, filter, find } from 'lodash';
import MetafieldDetailViewCardData from 'components/Cases/components/Detail/MetafieldDetailViewCardData';

const MetafieldDetails = ({ metafields, metadata }) => {
  // Filter out file type metafields and metadata.
  // Prevents metadata section from rendering when only file metadata exists.
  const filteredMetafields = filter(metafields, (field) => field.type !== 'file');

  const filteredMetadata = filter(
    metadata,
    (field) => find(filteredMetafields, ['field', field.field]),
  );

  if (isEmpty(filteredMetafields) && isEmpty(filteredMetadata)) {
    return null;
  }

  return (
    <>
      <hr className="border-dark-fill-blue" />
      <div className="py-2">
        <MetafieldDetailViewCardData
          metafields={filteredMetafields}
          metadata={filteredMetadata}
        />
      </div>
    </>
  );
};

MetafieldDetails.propTypes = {
  metafields: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
  })).isRequired,
  metadata: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.string),
  })).isRequired,
};

export default MetafieldDetails;
